//export const MATERIAL_URL = `http://localhost:5001/material/`;
export const MATERIAL_URL = `https://node.matlib.net/material/`;
//export const ROOT_SERVER = `http://localhost:5001/`;
export const ROOT_SERVER = `https://node.matlib.net/`;
export const NIKESTORE = `https://node.matlib.net/brand/`;
